// @flow
import React from 'react';
import { getIn, useFormikContext } from 'formik';
import {
  CLUSTER_TYPE_BACKEND_NAME,
  FREIGHT_CLUSTER_TYPE,
  TABLEFLOW_VERSIONS,
} from '@src/constants';

import { PaddedAndRaisedSegment } from '../../presentational/PaddedAndRaisedSegment';
import { ClusterInputTable } from '../cluster-input-table/ClusterInputTable';
import { isAnyOfTheClusterRelatedFormsEdited } from '../cluster-details-inputs/utils';
import { getIfConfluentStorageIsEnabledFromFormikValues } from '../cluster-monthly-inputs/utils';
import { useTableflowVersion } from '../../../custom-hooks/useTableflowVersion';

const getAllKeysSentByBE = (values) => {
  const calculations = getIn(values, 'calculations');
  return Object.keys(calculations?.months?.['Month 1'] ?? {});
};

export const ClusterCalculationsContainer = () => {
  const { values, initialValues } = useFormikContext();
  const disabled = isAnyOfTheClusterRelatedFormsEdited(values, initialValues);
  const allKeysSentByBE = getAllKeysSentByBE(values);
  const tableflowVersion = useTableflowVersion();
  const isLegacyTableflow = tableflowVersion === TABLEFLOW_VERSIONS.LEGACY;

  const rowsConfig = [
    {
      backendName: 'ckus',
      displayName: 'CKUs',
      showOrHideFunc: () => allKeysSentByBE.includes('ckus'),
    },
    {
      backendName: 'eckus',
      displayName: 'ECKUs',
      showOrHideFunc: () => allKeysSentByBE.includes('eckus'),
    },
    {
      backendName: 'storage_minus_replication_gbs',
      displayName: 'Storage Excl. Replication (GB) - ( Non TF Topics )',
      showOrHideFunc: (values) => values[CLUSTER_TYPE_BACKEND_NAME] !== FREIGHT_CLUSTER_TYPE,
    },
    {
      backendName: 'storage_including_replication_gbs',
      displayName: 'Storage After Replication (GB) - ( Non TF Topics )',
      showOrHideFunc: (values) => values[CLUSTER_TYPE_BACKEND_NAME] !== FREIGHT_CLUSTER_TYPE,
    },
    {
      backendName: 'storage_tf_topics_minus_replication_gbs',
      displayName: 'Storage Excl. Replication (GB) - ( TF Topics )',
      showOrHideFunc: (values) => values[CLUSTER_TYPE_BACKEND_NAME] !== FREIGHT_CLUSTER_TYPE,
    },
    {
      backendName: 'storage_tf_topics_including_replication_gbs',
      displayName: 'Storage After Replication (GB) - ( TF Topics )',
      showOrHideFunc: (values) => values[CLUSTER_TYPE_BACKEND_NAME] !== FREIGHT_CLUSTER_TYPE,
    },
    {
      backendName: 'storage_minus_replication_gbs',
      displayName: 'Storage (GB) - ( Non TF Topics )',
      showOrHideFunc: (values) => values[CLUSTER_TYPE_BACKEND_NAME] === FREIGHT_CLUSTER_TYPE,
    },
    {
      backendName: 'storage_tf_topics_minus_replication_gbs',
      displayName: 'Storage (GB) - ( TF Topics )',
      showOrHideFunc: (values) => values[CLUSTER_TYPE_BACKEND_NAME] === FREIGHT_CLUSTER_TYPE,
    },
    // TODO::CE1 - Confirm if BE is going to handle getIfConfluentStorageIsEnabledFromFormikValues(values) and if yes, replace it with allkeyssentbybe.includes('tableflow_storage_gbs')
    // Tableflow Storage is only applicable to Legacy Tableflow and not for Tableflow V2
    {
      backendName: 'tableflow_storage_gbs',
      displayName: 'Tableflow Storage (GB)',
      showOrHideFunc: (values) =>
        isLegacyTableflow &&
        getIfConfluentStorageIsEnabledFromFormikValues(values, tableflowVersion),
    },
  ];

  return (
    <PaddedAndRaisedSegment disabled={disabled}>
      <ClusterInputTable
        isReadOnly={true}
        keyNameInValues="calculations"
        rowsConfig={rowsConfig}
        tableName="Cluster Calculations"
      />
    </PaddedAndRaisedSegment>
  );
};
